<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column type="index" width="80"></el-table-column>
      <el-table-column prop="Id" label="订单编号" width sortable></el-table-column>
      <el-table-column prop="Uniqid" label="手机" width sortable></el-table-column>
      <el-table-column prop="existsOrders" label="交易类型" :formatter="formatorder" width ></el-table-column>
      <el-table-column prop="point" label="交易积分" width sortable></el-table-column>
      <el-table-column prop="jjvcstoredata_Id" label="归属门店" width sortable></el-table-column>
      <el-table-column prop="reg_ip" label="ip" width sortable></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width sortable></el-table-column>
      <el-table-column prop="status" label="状态" width="200" :formatter="formatorder">
        <template slot-scope="scope">
          <el-tag
            :type="(scope.row.level=='' ||scope.row.level<3)&&scope.row.status==1 ? 'success' : 'danger'"
            disable-transitions
          >{{(scope.row.level=='' ||scope.row.level<3)&&scope.row.status==1 ? "正常":scope.row.status==0?"注销":"高风险("+scope.row.level+")"}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-form-item label="ID" prop="Id">
          <el-input v-model="editForm.Id" readonly auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="Phone">
          <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="editForm.status" placeholder="请选择角色状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风险等级" prop="level">
          <el-select v-model="editForm.level" placeholder="请选择风险等级">
            <el-option
              v-for="item in levelList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="风险原因" prop="riskType">
          <el-input v-model="editForm.riskType" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="归属门店" prop="jjvcstoredata_Id">
          <el-input v-model="editForm.jjvcstoredata_Id" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册渠道">
          <el-input v-model="editForm.ext_json.brand" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="放开限制">
          <el-switch
            active-value="1"
            inactive-value="0"
            on-text
            off-text
            v-model="editForm.ext_json.limit_four_luminosity"
          ></el-switch>光度不限制
          <el-switch
            active-value="1"
            inactive-value="0"
            on-text
            off-text
            v-model="editForm.ext_json.limit_product_days"
          ></el-switch>天数不限制
          <el-switch
            active-value="1"
            inactive-value="0"
            on-text
            off-text
            v-model="editForm.ext_json.limit_purchase_box"
          ></el-switch>盒数不限制
        </el-form-item>
        <el-form-item label="更换手机" v-if="editForm.ext_json.change_phone">
          <el-time-picker
            type="datetimerange"
            placeholder="选择时间"
            v-model="editForm.ext_json.change_phone_time"
            style="width: 50%;"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            readonly
          ></el-time-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  getMember_jjvc,
  Member_delete,
  Member_edit,
  Member_add
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ""
      },
      buttonList: [],
      users: [],
      statusList: [
        { name: "激活", value: 1 },
        { name: "禁用", value: 0 }
      ],
      levelList: [
        { name: "无风险", value: 0 },
        { name: "风险值1", value: 1 },
        { name: "风险值2", value: 2 },
        { name: "风险值3", value: 3 },
        { name: "风险值4", value: 4 }
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: false, message: "请输入角色名", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        // Id: 0,
        // CreateBy: "",
        // Name: "",
        // Enabled: false
        ext_json: []
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入角色名", trigger: "blur" }],
        level: [{ required: true, message: "请选择等级", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        Name: "",
        Enabled: true
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    formatorder: function(row, column) {
      return row.existsOrders == 0 ? "未购买" : "已购买";
    },
    // 解码
    formadecodeUnicode: function(row, column) {
      return !row.Name || row.Name == ""
        ? ""
        : unescape(row.Name.replace(/\\/g, "%"));
    },
    decodeUnicode: function(str) {
      return !str || str == "" ? "" : unescape(str.replace(/\\/g, "%"));
    },
    //编码
    decToHex: function(str) {
      if (str == "") {
        return "";
      }
      var res = [];
      for (var i = 0; i < str.length; i++)
        res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
      return "\\u" + res.join("\\u");
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getRoles();
    },
    //获取用户列表
    getRoles() {
      let _this = this;
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getMember_jjvc(para).then(res => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //由于接口返回的扩展字段是字符串，所以转成对象用于数据绑定
        for (let index = 0; index < this.users.length; index++) {
          const element = this.users[index];
          this.users[index].Name = this.decodeUnicode(element.Name);
          this.users[index].ext_json = JSON.parse(element.ext_json);
          if (element.ext_json == null) {
            this.users[index].ext_json = {
              change_phone: false,
              change_phone_time: "",
              brand: "",
              limit_four_luminosity: "0",
              limit_product_days: "0",
              limit_purchase_box: "0"
            };
          }
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeRole(para).then(res => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error"
              });
            }

            this.getRoles();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        Name: "",
        Enabled: ""
      };
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);
            para.ext_json = JSON.stringify(para.ext_json);
            para.Name = this.decToHex(para.Name);
            Member_edit(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getRoles();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getRoles();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
</style>
